import React from "react";
import {useServices} from "../../../hooks/use-services.hook";
import {PrintTicketButtonComponent} from "../../../components/print-ticket/print-ticket-button.component";
import {observer} from "mobx-react";
//import {ShowTicketDialogButtonComponent} from "../../../components/print-ticket/show-ticket-dialog-button.component";
//import {ApplicationEnvironmentTypeEnum} from "../../../services/configuration/configuration-object.interface";

export const ManageMyBookingDashboardHeaderTopMiddleSectionComponent: React.FC = observer(() => {
    const services = useServices();
    const booking = services.booking.current;
    return (
        <PrintTicketButtonComponent booking={booking} hideLabel={false}/>
    )

    /*
    const renderShowTicketButton = () => {
        if(services.configuration.envConfigs.currentEnvironmentType === ApplicationEnvironmentTypeEnum.Development) {
            return (<ShowTicketDialogButtonComponent booking={booking}/>);
        }
        return null;
    }

    return (
        <div>
            <PrintTicketButtonComponent booking={booking} hideLabel={false}/>
            {renderShowTicketButton()}
        </div>
    )
    */
})
